/**
 * @internal
 */
var pipe1 = function pipe1(a, f) {
  return a instanceof Promise ? a.then(f) : f(a);
};

export default pipe1;